// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container--iCozS","MainRoute":"MainRoute--1Lru-","HeaderControls":"HeaderControls--1zAaj","Version":"Version--fNvBV","StickyControlPanel":"StickyControlPanel--14Uiu","ConfirmationContainer":"ConfirmationContainer--7olos"};


//////////////////
// WEBPACK FOOTER
// ./src/app/app.scss
// module id = 64
// module chunks = 1